// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nSnc","icon":"styles_icon__3kj13"};